import { render } from "./VsSidebar.vue?vue&type=template&id=d46b99fe"
import script from "./VsSidebar.vue?vue&type=script&lang=js"
export * from "./VsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__